<template>
  <div :gutter="20" class="page-filterBasic" v-loading="loading">
    <basic-info :info="person" @show-assign="showAssignModal" @update="getFilterPerson"></basic-info>
    <abstract-info v-if="person.id" :info="person" :configType="0" />
    <more-info ref="moreInfo" v-if="person.id" :info="person" :dataSource="person.filtrate_records" style="margin-top: 10px;flex:1" @success="getFilterPerson"></more-info>
    <Modal v-model="assignModal" width="550">
      <div slot="header" style="text-align: center">
        <span>分配管理方案</span>
      </div>
      <Form
        ref="formAssign"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem required label="管理方案">
          <Select v-model="curAssign.template_id" v-infinite-scroll="handleReachBottom" @on-change="handleSelectTemplate">
            <Option v-for="a in assignList" :key="a.id" :value="a.id">{{a.name}}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="curAssign.template_id" required label="开始阶段">
          <Select v-model="curAssign.start_period_id">
            <Option v-for="a in periodList" :key="a.id" :value="a.id">{{a.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="开始日期" required>
          <DatePicker v-model="curAssign.start_date" type="date"></DatePicker>
          <!-- <Checkbox v-model="curAssign.isCheck" style="position: relative;top: 16px">是否开启IM会话</Checkbox> -->
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelAssignModal">取消</el-button>
        <el-button
          type="primary"
          round
          :loading="assignModalLoading"
          @click="saveAssign"
        >分配</el-button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { formatDate } from "../../../utils/date"
import { getFilterPersonApi } from "../../../api/user";
import { getPatientSchemeListApi, getSchemeListApi, assignSchemeApi, getSchemeDetailApi } from "../../../api/scheme"
import BasicInfo from "./basicInfo.vue";
import MoreInfo from "./moreInfo.vue";
import abstractInfo from "../components/abstractInfo.vue"
export default {
  components: {
    BasicInfo,
    MoreInfo,
    abstractInfo
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      person: {},
      assignModal: false,
      assignModalLoading: false,
      curAssign: {},
      assignList: [],
      loading: false,
      periodList: [],
      page: 1,
      size: 20,
      total: 0
    };
  },
  computed: {
    // periodList() {
    //   if (this.curAssign.template_id) {
    //     const cur = this.assignList.find(a => a.id == this.curAssign.template_id);
    //     if (cur) {
    //       return [].concat(cur).concat(cur.child_templates || []);
    //     }
    //   }
    //   return []
    // }
  },
  created() {
    this.getFilterPerson();
  },
  methods: {
    handleSelectTemplate(value) {
      if (value) {
        this.getSchemeDetail(value);
      } else {
        this.curAssign.start_period_id = value
      }
    },
    showAssignModal() {
      this.getSchemeList();
      this.assignModal = true;
    },
    cancelAssignModal() {
      this.curAssign = {};
      this.assignList = []
      this.assignModalLoading = false
      this.assignModal = false;
    },
    getSchemeDetail(id) {
      getSchemeDetailApi({id}).then(res => {
        if (res.code === 0) {
          this.periodList = [].concat(res.data).concat(res.data.child_templates || []);
          this.curAssign.start_period_id = id;
        } else {
          const cur = this.assignList.find(a => a.id == id);
          this.periodList = [cur]
          this.curAssign.start_period_id = id;
          this.$Message.error(res.message);
        }
      })
    },
    saveAssign() {
      this.assignModalLoading = true;
      const { start_period_id, template_id, start_date } = this.curAssign;
      const { user_id } = this.person;
      assignSchemeApi({patient_id: user_id, start_period_id, template_id, start_date: formatDate(start_date)}).then(res => {
        this.assignModalLoading = false
        if (res.code === 0) {
          this.assignModal = false;
          this.$refs.moreInfo.getTreatInfo();
        } else {
          this.$Message.error(res.message);
        }
      })
    },
    getFilterPerson() {
      this.loading = true
      getFilterPersonApi(this.user.id).then(res => {
        if (res.code === 0) {
          this.person = res.data;
          if (!this.person.filtrate_records) {
            this.person.filtrate_records = [];
          }
        } else {
          this.$Message.error(res.message);
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getSchemeList() {
      this.page = 1;
      this.size = 20;
      const is_draft = 0;
      getSchemeListApi({page: this.page, size: this.size, is_draft}).then(res => {
        if (res.code === 0) {
          this.assignList = res.data;
          if (res.data && res.data.length) {
            this.curAssign = {
              template_id: res.data[0].id,
              start_period_id: res.data[0].id,
              start_date: new Date()
            }
            this.getSchemeDetail(res.data[0].id);
          }
          this.total = res["x-total-count"];
        }
      });
    },
    handleReachBottom() {
      if (this.page * this.size < this.total) {
        this.page = this.page + 1;
        const is_draft = 0;
        getSchemeListApi({page: this.page, size: this.size, is_draft}).then(res => {
          if (res.code === 0) {
            this.assignList = this.assignList.concat(res.data);
            this.total = res["x-total-count"];
          }
        });
      }
    },
    getPatientSchemeList() {
      getPatientSchemeListApi().then(res => {
        if (res.code === 0) {}
      })
    }
  }
};
</script>
<style lang="less">
  .page-filterBasic{
    .ivu-tabs {
      overflow: hidden !important;
    }
  }
</style>
